import { Box, Text, Button, TextInput, Tooltip } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "./style.css";
import PreviousRecurringInvoices from "./PreviousRecurringInvoices";
import { IoMdAdd } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import { getAllBillingRecurringInvoices } from "../../../../services/billinginvoice";
import { useSelector } from "react-redux";
const RecurringInvoices = ({ setState }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);


   const { stripeaccounts  } = useSelector(
      (state) => state.settinginvoice
    );
       const {settingInvoice} = useSelector(
          (state) => state.settinginvoice
        );
    

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query); // Update the search query state

    // Clear the previous timeout to reset the debouncing process
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // Set a new timeout to call the API after 500ms delay
    const timeout = setTimeout(() => {
      getAllBillingRecurringInvoices({ query, page: 1 }); // Trigger the API call
    }, 500); // 500ms delay

    setDebounceTimeout(timeout); // Store the timeout ID to clear it later
  };

  useEffect(() => {
    // Cleanup the timeout when the component unmounts
    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [debounceTimeout]);

  return (
    <div className="maindashbordinvoices">
      <Box className="allInvoicesSection">
        <Text fs={16} fw={700} color="#171717">
          All Recurring Invoices
        </Text>
        <div style={{ display: "flex", gap: "1rem" }}>

{
  (
    !stripeaccounts?.StripeAccounts || (
      stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
      (
        settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
        settingInvoice?.settinginvoice?.paymentsOptions?.ach
      )
    )
  ) ? (
    <Tooltip
      label="Your stripe account is not registered, go to settings tab and update it."
      withArrow
      position="bottom"
    >
      <img
        width={20}
        height={20}
        style={{ position: "relative", top: "13px" }}
        src="/assets/images/error.png"
        alt="check-icon"
      />
    </Tooltip>
  ) : null
}


          <Button
            onClick={() => {
              setState(true);
            }}
            disabled={
              !stripeaccounts?.StripeAccounts || (
                stripeaccounts?.StripeAccounts?.stripeAccountStatus === 'pending' &&
                (
                  settingInvoice?.settinginvoice?.paymentsOptions?.debitCredit ||
                  settingInvoice?.settinginvoice?.paymentsOptions?.ach
                )
              )
            }
            variant="filled"
            type="submit"
            c={"#000"}
            radius={"md"}
            size="md"
            color="yellow"
            style={{ display: "flex", gap: ".5rem" }}
          >
            <IoMdAdd size={25} />
            <div style={{ marginLeft: ".5rem" }}>New Invoice</div>
          </Button>
        </div>
      </Box>
      <Box className="dashbordinvoices">
        <div style={{ display: "flex", gap: "1rem" }}>
          <TextInput
            rightSection={<CiSearch size={20} color="#737373" />}
            className="search-section"
            // left={<CiSearch />}
            placeholder="Search Customer name, Invoice ID"
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
        <PreviousRecurringInvoices />
      </Box>
    </div>
  );
};

export default RecurringInvoices;
